<div class="flex-header mat-dialog-title" translate>
  Help
</div>
<div class="flex-content" translate>

  <mat-accordion style="padding: 10px;">
    <mat-expansion-panel [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title translate>
          Hiding/Showing Cards
        </mat-panel-title>
        <mat-panel-description>
          <!--Description-->
        </mat-panel-description>
      </mat-expansion-panel-header>
      <div style="display: flex; flex: 1; flex-direction: row">
        <div style="display: flex; flex-direction: column; flex: 2">
          <p translate>
            The different ares that display information on the Student Summary page are called "cards". Cards can be shown in summary view, detailed view, or turned off. (Some cards do not have a summary option based on the type of information they show.)
          </p>
          <p translate>
            The top image on the right shows what the Attendance card looks like in summary view and the bottom example shows it in detailed view.
          </p>
          <ul style="padding: 10px 10px 10px 20px;">
            <li style="padding: 5px" translate>Summary vies show only a limited amount of information, usually just counts or totals, so they take up less space, allowing more cards to be seen at once.</li>
            <li style="padding: 5px" translate>Detailed views show more information, so they take up more space. The height of these cards will adjust based on the content to be displayed.</li>
          </ul>
          <p translate>
            When a summary card is being shown, selecting it will display the information that would have been shown on the detailed card, so regardless of which way the card is being shown, the detailed information is easily accessible.
          </p>
        </div>
        <div style="display: flex; flex-direction: column; flex: 1">
          <div style="display: flex; flex-direction: row; padding: 5px"><img src="./assets/images/attendanceSummaryCard.png"/></div>
          <div style="display: flex; flex-direction: row; padding: 5px"><img style="height: 226px" src="./assets/images/attendanceDetailCard.png"/></div>
        </div>
      </div>
    </mat-expansion-panel>
  </mat-accordion>

  <mat-accordion style="padding: 10px;">
    <mat-expansion-panel [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title translate>
          Rearranging the Cards
        </mat-panel-title>
        <mat-panel-description>
          <!--Description-->
        </mat-panel-description>
      </mat-expansion-panel-header>
      <p translate>
        The order in which the cards are displayed can be changed by dragging rows up and down in the list.
      </p>
      <p translate>
        The cards display in two columns. The Column Break indicator can be moved up or down to define where the second column begins - rows above the Column Break indicator will show in the first column, rows below it will show in the second column.
      </p>
    </mat-expansion-panel>
  </mat-accordion>

</div>
<div class="flex-footer">
  <div class="flex-footer-right">
    <tyl-button image="cancel.png" label="Close" (clickEvent)="closeClick()" translate></tyl-button>
  </div>
</div>
